import { addPending, completePending } from "./actions";
import { IPendingItem } from "./types";
import { Dispatch } from "react";
import { Action } from "redux";

export function selectStatusDispatch(dispatch: Dispatch<Action<any>>) {
  return {
    addPending: (item: IPendingItem) => dispatch(addPending(item)),
    completePending: (item: IPendingItem) => dispatch(completePending(item)),
  };
}
